/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateFragmentCreationMutationRequest, WebAppCreateFragmentCreationMutationResponse } from "../models/WebAppCreateFragmentCreation";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCreateFragmentCreation } from "../axios/webAppCreateFragmentCreation";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCreateFragmentCreationMutationKey = () => [{ url: '/web-app/fragments' }] as const

export type WebAppCreateFragmentCreationMutationKey = ReturnType<typeof webAppCreateFragmentCreationMutationKey>

export function webAppCreateFragmentCreationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCreateFragmentCreationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCreateFragmentCreationMutationKey()
        return mutationOptions<WebAppCreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: WebAppCreateFragmentCreationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return webAppCreateFragmentCreation(data, config)
          },
        })

}

/**
 * @summary Create a fragment
 * {@link /web-app/fragments}
 */
export function useWebAppCreateFragmentCreation<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: WebAppCreateFragmentCreationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCreateFragmentCreationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCreateFragmentCreationMutationKey()

          const baseOptions = webAppCreateFragmentCreationMutationOptions(config) as UseMutationOptions<WebAppCreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: WebAppCreateFragmentCreationMutationRequest}, TContext>
          

          return useMutation<WebAppCreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: WebAppCreateFragmentCreationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: WebAppCreateFragmentCreationMutationRequest}, TContext>
      
}